import { StoreDeliveryConfigurations } from "../../entity/StoreDeliveryConfiguration";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface StoreConfigState {
  storeConfig: StoreDeliveryConfigurations[] | undefined;
}

const initialState: StoreConfigState = {
  storeConfig: undefined,
};

const storeConfigSlice = createSlice({
  name: "storeConfig",
  initialState,
  reducers: {
    setStoreConfig: (
      state,
      action: PayloadAction<StoreDeliveryConfigurations[] | undefined>,
    ) => {
      state.storeConfig = action.payload;
    },
  },
});

export const { setStoreConfig } = storeConfigSlice.actions;
export default storeConfigSlice.reducer;
